var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 38,
    height: 8,
    rx: 1,
    fill: "#147D64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4 11C4 10.4477 4.44772 10 5 10H41C41.5523 10 42 10.4477 42 11V29C42 29.5523 41.5523 30 41 30H5C4.44772 30 4 29.5523 4 29V11Z",
    fill: "#65D6AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2739 16V22.2H20.4639V23H16.9439V22.2H18.3739V17.15L17.0339 18.16L16.5439 17.49L18.6139 16H19.2739ZM24.38 23C24.36 22.88 24.35 22.7567 24.35 22.63C24.35 22.2033 24.4267 21.8167 24.58 21.47C24.74 21.1233 24.9367 20.81 25.17 20.53C25.4033 20.2433 25.6533 19.98 25.92 19.74C26.1933 19.4933 26.4467 19.26 26.68 19.04C26.9133 18.8133 27.1067 18.59 27.26 18.37C27.42 18.1433 27.5 17.9033 27.5 17.65C27.5 17.37 27.3967 17.14 27.19 16.96C26.9833 16.7733 26.7167 16.68 26.39 16.68C26.11 16.68 25.8533 16.7367 25.62 16.85C25.3933 16.9567 25.18 17.1033 24.98 17.29L24.48 16.68C24.7467 16.44 25.04 16.2467 25.36 16.1C25.6867 15.9533 26.0633 15.88 26.49 15.88C26.7833 15.88 27.05 15.9233 27.29 16.01C27.5367 16.0967 27.7433 16.22 27.91 16.38C28.0833 16.5333 28.2167 16.7133 28.31 16.92C28.4033 17.1267 28.45 17.35 28.45 17.59C28.45 17.91 28.3767 18.2067 28.23 18.48C28.09 18.7467 27.91 19.0033 27.69 19.25C27.4767 19.49 27.24 19.7233 26.98 19.95C26.7267 20.17 26.4867 20.3967 26.26 20.63C26.0333 20.8633 25.8333 21.1067 25.66 21.36C25.4933 21.6133 25.3933 21.8867 25.36 22.18H28.44V23H24.38Z",
    fill: "#147D64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsActive);
export default __webpack_public_path__ + "static/media/events-active.acfb0fd2bc1408e2eb2838e88b1702e5.svg";
export { ForwardRef as ReactComponent };